import { TFunction } from "i18next";
import { z } from "zod";

export const getDepthMeasurementRecordFormSchema = (t: TFunction) => {
  return z.object({
    startDepth: z
      .number({
        required_error: t("captures.capture.depth-measurement.errors.start-depth-required"),
        invalid_type_error: t("captures.capture.depth-measurement.errors.start-depth-required"),
      }),
    endDepth: z
      .number({
        required_error: t("captures.capture.depth-measurement.errors.end-depth-required"),
        invalid_type_error: t("captures.capture.depth-measurement.errors.end-depth-required"),
      }),
    variableId : z
      .number({
        required_error: t("captures.capture.depth-measurement.errors.variable-required"),
        invalid_type_error: t("captures.capture.depth-measurement.errors.variable-required"),
      }),
    value: z
      .number({
        required_error: t("captures.capture.depth-measurement.errors.value-required"),
        invalid_type_error: t("captures.capture.depth-measurement.errors.value-required"),
      }),
    flag: z.string().nullable().optional(),
    measuredAt: z.string().nullable().optional(),
  });
};

export type DepthMeasurementRecordForm = z.infer<ReturnType<typeof getDepthMeasurementRecordFormSchema>>;